import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Time',
  field: 'Measurement',
  weeks: [4, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'OClockAndHalfPast',
      questionTypes: ['bkR', 'bkS', 'bkT'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/1OClockAndHalfPast" */ './1OClockAndHalfPastModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'QuarterPastAndQuarterTo',
      questionTypes: ['bkU', 'bkV', 'bkW'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/2QuarterPastAndQuarterTo" */ './2QuarterPastAndQuarterToModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'TellTimePastTheHour',
      questionTypes: ['bkX', 'bkY', 'bkZ'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/3TellTimePastTheHour" */ './3TellTimePastTheHourModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'TellTimeTimeToTheHour',
      questionTypes: ['bk0', 'bk1', 'bk2'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/4TellTimeTimeToTheHour" */ './4TellTimeTimeToTheHourModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'TellTheTimeTo5MinutesY2',
      questionTypes: ['bk3', 'bk4', 'bk5'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/5TellTheTimeTo5MinutesY2" */ './5TellTheTimeTo5MinutesY2Models'
        )
    }),
    // Step 6
    newSmallStepContent({
      smallStep: 'MinutesInAnHour',
      questionTypes: ['bk6', 'bk7', 'bk8'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/6MinutesInAnHour" */ './6MinutesInAnHourModels'
        )
    }),
    // Step 7
    newSmallStepContent({
      smallStep: 'HoursInADay',
      questionTypes: ['bk9', 'bla', 'blb'],
      archivedQuestionTypes: [],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Time/7HoursInADay" */ './7HoursInADayModels')
    })
  ]
});
export default Block;
